import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/lib/axios";

export const fetchActionItems = createAsyncThunk(
  "actionItems/fetch",
  async (caseId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/action_items", {
        params: { case_id: caseId },
        headers: {
          accept: "application/json",
        },
      });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch action items"
      );
    }
  }
);

export const addActionItem = createAsyncThunk(
  "actionItems/add",
  async (actionItems: any[], { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/add_action_items",
        actionItems,
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
     } catch (error: any) {
       return rejectWithValue(
         error?.response?.data?.message || "Failed to add action items"
       );
     }
  }
);

export const deleteActionItem = createAsyncThunk(
  "actionItems/delete",
  async (actionItemId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/delete_action_items`, {
        params: {
          action_items_id: actionItemId,
        },
        headers: {
          accept: "application/json",
        },
      });
      return actionItemId;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete action item"
      );
    }
  }
);
